import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import { FormControl } from "@mui/material";
interface Props {
  open: boolean;
  categoryLoading: boolean;
  handleClose: () => void;
  updateCategory: (data: any) => void;
  modalData: any;
  categoryList: any;
}

export default function AddNewNodeModal({
  open,
  categoryLoading,
  handleClose,
  modalData,
  updateCategory,
  categoryList
}: Props) {  
  const [validateError, setvalidateError] = useState<any>([]);
  const [categoryData, setCategoryData] = useState<any>(
    modalData || { category_name: "" }
  );
  const [error, setError] = useState(false);

  const handleChange = (event: any) => {
    setCategoryData({
      ...categoryData,
      category_name: event.target.value,
    });
  };

  const handleUpdate = () => {
    if (checkValidate(categoryData).length === 0) {
        updateCategory(categoryData);
    }    
  };
  const checkValidate = (data: any) => {
    let error = [];
    if (data.category_name === "") {
      error.push("category_name");
    }
    if(checkOrderNumberExists(categoryList, data.order_number)){
      error.push("order_number");
    }   
    if(!!data.category_name && checkCategoryNameExists(categoryList, data.category_name)){
      error.push("category_name_exists");
    }   
    setvalidateError(error);
    return error;
  };

  const checkOrderNumberExists = (arr:any, orderNumber:any) => {
    let exists = false
    if(!!modalData.pk && !!modalData.sk){
        exists = arr.some((item:any) => item.order_number === orderNumber && item.sk !== modalData.sk);
    }else{
        exists = arr.some((item:any) => item.order_number === orderNumber);
    }    
    return exists;
  };

  const checkCategoryNameExists = (arr:any, cateName:any) => {
    let exists = false
    if(!!modalData.pk && !!modalData.sk){
        exists = arr.some((item:any) => item.category_name.toLowerCase() === cateName.toLowerCase() && item.sk !== modalData.sk);
    }else{
        exists = arr.some((item:any) => item.category_name.toLowerCase() === cateName.toLowerCase());
    }    
    return exists;
  };

  return (
    <div>
          <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
              {!!modalData.pk ? `Edit Category [${categoryData.category_name}]` : "Add Category"}
            </DialogTitle>
            <DialogContent>              
              <TextField
                margin="normal"
                required
                fullWidth
                id="category_name"
                label="Category Name"
                name="category_name"
                autoComplete="category_name"
                autoFocus
                inputProps={{
                  maxLength: 20,
                }}
                value={categoryData?.category_name}
                onChange={handleChange}
                error={["category_name", "category_name_exists"].some((msg) => validateError.includes(msg))}
                helperText={
                  validateError.includes("category_name")
                  ? "Please Enter Category Name"
                  : validateError.includes("category_name_exists")
                  ? "Category Name Already Exists"
                  : ""
                }
              />
              <TextField
                margin="normal"                
                fullWidth
                id="order_number"
                label="Order Number"
                name="order_number"
                inputProps={{
                  maxLength: 20,
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
                value={categoryData?.order_number}
                onChange={(e) => {
                  const { name, value } = e.target;
                  if (/^\d*$/.test(value)) {
                    setCategoryData((prev: any) => ({ ...prev, [name]: value }));
                  }
                }}
                error={validateError.includes("order_number")}
                helperText={
                  validateError.includes("order_number") &&
                  "Order Number Already exits"
                }
              />                
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <LoadingButton
                loading={categoryLoading}
                variant="contained"
                onClick={() => handleUpdate()}
              >
                {!!modalData.pk ? "Update" : "Save"}
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </div>
  );
}
